export const getDataForSubmit = (formData) => {
    let postData = {
        "type": formData.type,
        "headline": formData.headline,
        "description": formData.description,
        "images": [
            {
                "content": formData.ogImage
            }
        ],
    }

    if(formData.id){
        postData.id = formData.id
    }

    switch (formData.type) {
        case 1: // Article
            return {
                ... postData,
                "components": formData.blocks,
                "leadIn":formData.leadIn,
                "imageCaption":formData.imageCaption,
                "tags":formData.tags
            }
        case 2: // External Link
            return {
                ... postData,
                "link": formData.externalLink
            }
        case 3: // Product
            return {
                ... postData,
                "release": formData.release,
                "products": productsForSubmit(formData.products),
                "likesHidden": formData.likesHidden,
                "commentsHidden": formData.commentsHidden,
            }
    }
}

const productsForSubmit = (products) =>{
    return products.map(product => {
        let elem = {}
        if(product.id){
            elem = {... elem, id: product.id}
        }
            return {
            ... elem,
                productId: product.productId,
                discountType: product.discountType,
                discountValue: product.discountValue,
                deleted: product.deleted ? product.deleted : 0
            }
        }
    );
}

/**
 *
 * @param bookmarks
 * @param posts
 * @returns {*[]}
 */
export function bookmarksToPost(bookmarks, posts) {

}
export function bookmarksToCollections(bookmarks, collections){
    let resultCollection = {...collections}

    // sort bookmark to according collection
    bookmarks.maps((bookmark) => {

    })

}
